<app-main-header></app-main-header>
<div class="content">
  <app-restrictions-table [archived]="true"></app-restrictions-table>
</div>
